
import api from '@/api';

const namespaced = true;

const state = {
  sites: [],
};

const mutations = {
  SET_SITES(state, sites) {
    state.sites = sites;
  },
  ADD_SITE(state, site) {
    state.sites.push(site);
  },
  SAVE_SITE(state, saveSite) {
    let index = -1;
    state.sites.forEach((site, i) => {
      if (saveSite.id === site.id) {
        index = i;
      }
    });
    state.sites.splice(index, 1, saveSite);
  },
};

const actions = {
  async fetchSites({ commit, dispatch, rootState }, clientId) {
    const sites = await dispatch(`fetchSitesForClient`, clientId || rootState[`model/client`].currentAdminClient.id);
    commit(`SET_SITES`, sites);
    return sites;
  },
  async fetchSitesForClient(store, clientId) {
    const { data: sites } = await api.get(`/sites/client/${clientId}`);

    return sites;
  },
  async fetchSitesForClientWithClientTags(store, clientId) {
    const { data: sites } = await api.get(`/sites/client/${clientId}?clientTags=1`);

    return sites;
  },
  async fetchSitesForMakerAndClient({ commit }, { makerId, clientId, setList = false }) {
    const { data: sites } = await api.get(`/sites/maker/${makerId}/client/${clientId}`);

    if (setList) {
      commit(`SET_SITES`, sites);
    }

    return sites;
  },
  async createSite(store, site) {
    try {
      const { data: newSite } = await api.post(`/sites/`, site);

      return newSite;
    } catch (e) {
      return null;
    }
  },
  async addSite({ commit, dispatch }, site) {
    const newSite = await dispatch(`createSite`, site);
    if (newSite) {
      commit(`ADD_SITE`, newSite);
    }
  },
  async saveSite({ commit }, site) {
    try {
      const { data: saveSite } = await api.put(`/sites/${site.Site_id || site.id}`, site);
      commit(`SAVE_SITE`, saveSite);
    } catch (e) { } // eslint-disable-line
  },
};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
